import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import filter from 'lodash/filter';
import { Empty, Tooltip, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import Table from './TableStyle';
import Box from '../../StoragePage/components/BoxSetting';
import AddLock from '../../StoragePage/components/AddLock';
import ModalUser from '../../Customers/components/ModalInfo';
import ModalManager from '../../Managers/components/ModalInfo';
import moment from 'moment';
import { ReactComponent as GrayTrash } from '../../../images/gray_trash.svg';
import { ReactComponent as RedTrash } from '../../../images/red_trash.svg';

const WrapperTooltip = styled.div`
  &&& {
    .ant-tooltip-inner {
      color: black;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 18px;
    }
  }
`;

function List({
  data,
  loading,
  deleteData,
  users,
  boxes,
  getBoxes,
  updateBox,
  getData,
  locks,
  getDevices,
  updateDevice,
  loadingDevice,
  postBox,
  updateUsers,
  getUsers,
  loadingBox,
  deleteUsers,
  limit,
}) {
  const { t } = useTranslation();
  const [dataCol, setdataCol] = useState([]);
  const [box, setBox] = useState(null);
  const [visibleBox, setVisibleBox] = useState(false);
  const [client, setClient] = useState(null);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleUser, setVisibleUser] = useState(false);
  const [user, setUser] = useState(null);
  const [visibleManager, setVisibleManager] = useState(false);
  const [manager, setManager] = useState(null);
  const columns = [
    {
      title: t('numberTr'),
      dataIndex: 'number',
      key: 'number',
      render: (text, record) => {
        return <div className="item-row">{record.number}</div>;
      },
      sorter: (a, b) => Number(a.number) - Number(b.number),
      width: '15%',
    },
    {
      title: t('date&time'),
      dataIndex: 'date',
      key: 'date',
      render: (text, record) => {
        return <div className="item-row">{record.date}</div>;
      },
      sorter: (a, b) => {
        return (
          moment(a.date, 'YYYY-MM-DD HH:mm').unix() -
          moment(b.date, 'YYYY-MM-DD HH:mm').unix()
        );
      },
      width: '14%',
    },
    {
      title: t('paid_till'),
      dataIndex: 'paid_till',
      key: 'paid_till',
      render: (text, record) => {
        return <div className="item-row">{record.paid_till}</div>;
      },
      sorter: (a, b) => {
        return (
          moment(a.paid_till, 'DD-MMMM-YY').unix() -
          moment(b.paid_till, 'DD-MMMM-YY').unix()
        );
      },
      width: '20%',
    },
    {
      title: t('storage'),
      dataIndex: 'storage',
      key: 'storage',
      width: '20%',
      render: (text, record) => {
        return (
          <div className="item-row">
            <Link to={`storages/${record.storage.id}`}>
              <span className="text-primary border-b-1 border-dotted border-linkLine">
                {record.storage.name}
              </span>
            </Link>
          </div>
        );
      },
      sorter: (a, b) => a.storage.name.localeCompare(b.storage.name),
    },
    {
      title: t('box'),
      dataIndex: 'box',
      key: 'box',
      render: (text, record) => {
        return (
          <div className="item-row">
            <span className="text-primary border-b-1 border-dotted border-linkLine">
              {record.box}
            </span>
          </div>
        );
      },
      width: '14%',
      sorter: (a, b) =>
        a.box.props.children.localeCompare(b.box.props.children),
    },
    {
      title: t('customer'),
      dataIndex: 'user',
      key: 'user',
      render: (text, record) => {
        return (
          <div className="item-row">
            <span className="text-primary border-b-1 border-dotted border-linkLine">
              {record.user}
            </span>
          </div>
        );
      },
      width: '14%',
      sorter: (a, b) =>
        a.user.props.children.localeCompare(b.user.props.children),
    },
    {
      title: '',
      dataIndex: 'icons',
      key: 'icons',
      render: (text, record) => {
        return <div className="item-row">{record.icons}</div>;
      },
      width: '14%',
    },
  ];

  const deleteTransatcion = (id) => {
    deleteData({
      id,
    });
  };

  const handleOpenBox = (value, data) => {
    setBox({
      ...value,
      transaction: {
        ...value.transaction,
        client_id: data.client.id,
        created_at: data.created_at,
        paid_till: data.paid_till,
      },
    });
    setVisibleBox(true);
    setClient(data.client);
    if (value.device) {
      setVisibleBox(true);
    } else {
      setVisibleAdd(true);
    }
  };

  const handleOpenUserModal = (data) => {
    if (data.role === 'client') {
      setUser(data);
      setVisibleUser(true);
    } else {
      console.log(data);
      setManager(data);
      setVisibleManager(true);
    }
  };

  useMemo(() => {
    if (data) {
      const dataForTable = map(
        reverse(sortBy(data, (item) => item.id)),
        (item) => {
          return {
            key: item.id,
            number: item.id,
            date: `${moment(item.created_at).format('DD.MM.YY')} в ${moment(
              item.created_at,
            ).format('hh:mm')}`,
            paid_till: moment(item.paid_till).format('DD MMMM YYYY'),
            storage: item.box.section.warehouse,
            box: (
              <div
                className="cursor-pointer"
                onClick={() => {
                  handleOpenBox(item.box, item);
                }}
              >
                {item.box.name}
              </div>
            ),
            user: (
              <div
                className="cursor-pointer"
                onClick={() => {
                  handleOpenUserModal(item.client);
                }}
              >{`${item.client.first_name} ${item.client.last_name}`}</div>
            ),
            icons:
              moment(item.created_at).format('DD.MM.YYYY') !==
              moment().format('DD.MM.YYYY') ? (
                <WrapperTooltip>
                  <Tooltip
                    placement="topRight"
                    color="#FDFDFE"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    overlayStyle={{
                      width: '503px',
                      maxWidth: 'initial',
                      padding: '23x',
                    }}
                    title={t('deleteTransactionPopower')}
                  >
                    <GrayTrash />
                  </Tooltip>
                </WrapperTooltip>
              ) : (
                <RedTrash
                  className="cursor-pointer"
                  onClick={() => {
                    deleteTransatcion(item.id);
                  }}
                />
              ),
          };
        },
      );
      setdataCol(dataForTable);
    }
  }, [data]);

  useMemo(() => {
    if (box) {
      const sorted = filter(data, (item) => {
        return item.id === box.transaction_id;
      });

      setBox({
        ...sorted[0].box,
        transaction: {
          ...sorted[0].box.transaction,
          client_id: sorted[0].client.id,
          created_at: sorted[0].created_at,
        },
      });
    }
  }, [data]);

  useEffect(() => {
    if (user) {
      const newData = filter(users, (item) => {
        return item.id === user.id;
      });
      setUser(newData[0]);
    }
  }, [users]);

  return (
    <Spin spinning={loading}>
      {dataCol.length !== 0 ? (
        <Table
          className="w-full"
          pagination={false}
          columns={columns}
          showSorterTooltip={false}
          dataSource={dataCol}
        />
      ) : (
        <Empty className="mt-50" />
      )}
      {box &&
        (box.device ? (
          <Box
            source="transaction"
            data={box}
            setBox={setBox}
            boxes={boxes}
            getBoxes={getBoxes}
            visible={visibleBox}
            setVisible={setVisibleBox}
            allUsers={users}
            transaction={data}
            updateBox={updateBox}
            getTransactions={getData}
            setUser={setClient}
            updateDevice={updateDevice}
            limit={limit}
            setUserVisible={setVisibleUser}
            userVisible={visibleUser}
            setUser={setUser}
          />
        ) : (
          <AddLock
            source="transaction"
            sectionName={box.section.name}
            sectionId={box.section.id}
            locks={locks}
            visible={visibleAdd}
            setVisible={setVisibleAdd}
            postBox={postBox}
            storageId={box.section.warehouse.id}
            getBoxes={getBoxes}
            getDevices={getDevices}
            box={box}
            boxName={box.name}
            updateDevice={updateDevice}
            updateBox={updateBox}
            // setBoxId={setBoxId}
            getTransactions={getData}
            setVisibleSetting={setVisibleBox}
            visibleSetting={visibleBox}
            loadingDevice={loadingDevice}
            limit={limit}
          />
        ))}
      {user ? (
        <ModalUser
          setUser={setUser}
          loadingBox={loadingBox}
          boxes={boxes}
          getBoxes={getBoxes}
          updateData={updateUsers}
          user={user}
          users={users}
          getUsers={getUsers}
          visible={visibleUser}
          setVisible={setVisibleUser}
          updateDevice={updateDevice}
          updateBox={updateBox}
          locks={locks}
          getDevices={getDevices}
          postBox={postBox}
          setBox={setBox}
          setVisibleAdd={setVisibleAdd}
          visibleAdd={visibleAdd}
          setVisibleBox={setVisibleBox}
          visibleBox={visibleBox}
        />
      ) : null}
      {manager ? (
        <ModalManager
          visible={visibleManager}
          setVisible={setVisibleManager}
          data={manager}
          setUser={setManager}
          deleteData={deleteUsers}
          updateData={updateUsers}
          getTransactions={getData}
        />
      ) : null}
    </Spin>
  );
}

List.propTypes = {};

export default List;
